export const OrganizationsIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2C10.3682 2 10.6667 2.29848 10.6667 2.66667V5.33333C10.6667 5.70152 10.3682 6 10 6H8.66667V7.33333H11.3333C11.7015 7.33333 12 7.6318 12 8V10H13.3333C13.7015 10 14 10.2985 14 10.6667V13.3333C14 13.7015 13.7015 14 13.3333 14H9.33333C8.96513 14 8.66667 13.7015 8.66667 13.3333V10.6667C8.66667 10.2985 8.96513 10 9.33333 10H10.6667V8.66667H5.33333V10H6.66667C7.03487 10 7.33333 10.2985 7.33333 10.6667V13.3333C7.33333 13.7015 7.03487 14 6.66667 14H2.66667C2.29848 14 2 13.7015 2 13.3333V10.6667C2 10.2985 2.29848 10 2.66667 10H4V8C4 7.6318 4.29848 7.33333 4.66667 7.33333H7.33333V6H6C5.63181 6 5.33333 5.70152 5.33333 5.33333V2.66667C5.33333 2.29848 5.63181 2 6 2H10ZM6 11.3333H3.33333V12.6667H6V11.3333ZM12.6667 11.3333H10V12.6667H12.6667V11.3333ZM9.33333 3.33333H6.66667V4.66667H9.33333V3.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};
